import React, { useState } from 'react';
import CompaniesPage from './pages/CompaniesPage';
import ProductsPage from './pages/ProductsPage';
import GenerateKitPage from './pages/GenerateKitPage';
import DownloadsPage from './pages/DownloadsPage';

const VIEWS = { HOME: 'home', COMPANIES: 'companies', PRODUCTS: 'products', GENERATE: 'generate', DOWNLOADS: 'downloads' };

const CARDS = [
  { key: VIEWS.COMPANIES, title: 'Companies', desc: 'Manage leads & clients', emoji: '🏢', glow: 'from-violet-600/40 to-fuchsia-500/40' },
  { key: VIEWS.PRODUCTS, title: 'Products', desc: 'Your product master', emoji: '📦', glow: 'from-sky-500/40 to-cyan-400/40' },
  { key: VIEWS.GENERATE, title: 'Generate Sales Kit', desc: 'Quotes, brochures, scripts & more', emoji: '⚡', glow: 'from-amber-500/40 to-rose-500/40' },
  { key: VIEWS.DOWNLOADS, title: 'Downloads', desc: 'This session\'s generated kits', emoji: '📥', glow: 'from-emerald-500/40 to-teal-400/40' },
];

// Drop into your routing, e.g.:
//   import SalesKitHome from './saleskit/SalesKitHome';
//   <Route path="/saleskit" element={<SalesKitHome />} />
export default function MiniERPSalesKitHome() {
  const [view, setView] = useState(VIEWS.HOME);
  const [history, setHistory] = useState([]);
  const goHome = () => setView(VIEWS.HOME);

  if (view === VIEWS.COMPANIES) return <CompaniesPage onBack={goHome} />;
  if (view === VIEWS.PRODUCTS) return <ProductsPage onBack={goHome} />;
  if (view === VIEWS.GENERATE) return <GenerateKitPage onBack={goHome} onGenerated={(entry) => setHistory((h) => [...h, entry])} />;
  if (view === VIEWS.DOWNLOADS) return <DownloadsPage history={history} onBack={goHome} />;

  return (
    <div className="min-h-screen bg-[#0B0B12] text-white px-4 py-10 sm:px-8 relative overflow-hidden">
      {/* ambient background glow — the one bold move, everything else stays quiet */}
      <div className="pointer-events-none absolute -top-32 -left-32 w-96 h-96 rounded-full bg-violet-600/20 blur-3xl" />
      <div className="pointer-events-none absolute top-1/3 -right-32 w-96 h-96 rounded-full bg-fuchsia-500/10 blur-3xl" />

      <div className="max-w-4xl mx-auto relative">
        <p className="text-[11px] uppercase tracking-[0.2em] text-violet-400 font-semibold mb-2">MiniERP · Sales Kit</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">Close deals faster.</h1>
        <p className="text-white/40 text-sm mb-8">Manage leads, build pitch material, and stop rewriting the same quotation.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {CARDS.map((c) => (
            <button
              key={c.key}
              onClick={() => setView(c.key)}
              className="group relative text-left rounded-3xl p-[1px] bg-gradient-to-br from-white/10 to-white/0 hover:from-white/20 transition"
            >
              <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${c.glow} opacity-0 group-hover:opacity-100 blur-xl transition duration-300`} />
              <div className="relative rounded-3xl bg-[#14141C] p-6 h-full">
                <span className="text-3xl">{c.emoji}</span>
                <h3 className="mt-3 font-bold text-lg tracking-tight">{c.title}</h3>
                <p className="text-sm text-white/40 mt-1">{c.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
